import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, allowedRoles }) => {
  const { isAuthenticated, user, isLoading } = useAuth();

  console.log('PrivateRoute check:', { 
    isAuthenticated, 
    user: user?.name, 
    userRole: user?.role,
    isLoading,
    path: window.location.pathname
  });

  // Check both context and localStorage for authentication
  const hasToken = !!localStorage.getItem('access_token');
  const hasUser = !!localStorage.getItem('user');
  
  // ALWAYS show loading if isLoading is true
  // This prevents premature redirects while auth context initializes
  if (isLoading) {
    console.log('PrivateRoute: Auth context still loading, showing spinner');
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#008B8B]"></div>
        <p className="ml-4 text-gray-600">Loading...</p>
      </div>
    );
  }
  
  // After loading is complete, check if we have valid auth
  // Trust the context first, fallback to localStorage
  if (!isAuthenticated && (!hasToken || !hasUser)) {
    console.log('PrivateRoute: Not authenticated after loading complete, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // If we have storage data but no context user, try to use the stored user for role check
  const effectiveUser = user || (hasUser ? JSON.parse(localStorage.getItem('user')!) : null);

  if (allowedRoles && effectiveUser && !allowedRoles.includes(effectiveUser.role)) {
    console.log('PrivateRoute: Role not allowed, redirecting to unauthorized');
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;